import { GridRowOrderChangeParams } from '@mui/x-data-grid-pro';
import { IDripFeeder, IDripFeederSource, ISources } from './types';
import { requestUpdateDripFeeder } from './request';

export const getSourcesColumnData = (sources: IDripFeederSource[] | null, mainSources: ISources[]) => {
  const rankedStr: string | undefined = sources
    ? sources?.reduce((acc: string, item: IDripFeederSource, index: number) => {
      if (item.isRankedSource) {
        const str = `${index ? ',' : ''} ${item.sourceName}`;
        acc += str;
      }
      return acc;
    }, '')
    : '';

  const rankedSources = sources?.filter((source) => source.isRankedSource).map((item) => item.sourceId) ?? [];
  const otherSources = sources?.filter((source) => !source.isIgnored && !source.isRankedSource).map((item) => item.sourceId) ?? [];
  const combinedArray = rankedSources?.concat(otherSources) ?? [];
  const ignoredSources = mainSources.filter((source) => !combinedArray?.includes(source.id));

  const otherCount = otherSources.length ?? 0;
  const ignoredCount = ignoredSources?.length ?? 0;

  return { rankedStr, otherCount, ignoredCount };
};

export const getHighestRank = (fetchedDripFeeders: IDripFeeder[]) =>
  Math.max(...fetchedDripFeeders.map(({ rank }) => rank)) + 1;

export const updateRowRank = (
  params: GridRowOrderChangeParams,
  fetchedDripFeeders: IDripFeeder[],
): Promise<[void, void]> => {
  const sorted = fetchedDripFeeders?.slice().sort((a, b) => a?.rank - b?.rank);

  return Promise.all([
    requestUpdateDripFeeder({
      ...params.row,
      rank: sorted?.[params.targetIndex].rank,
    }),
    requestUpdateDripFeeder({
      ...sorted?.[params.targetIndex],
      rank: params.row.rank,
    }),
  ]);
};
